module.exports = __webpack_public_path__ + "static/media/GoogleIcon.a4d9f2c5.svg";